import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loading from '../Loading';

function PrivateRoute({ children }) {
    const { user, loadingAuth } = useAuth();

    if (loadingAuth) {
        return <Loading />
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    return children;
}

export default PrivateRoute;